module.exports = __webpack_public_path__ + "img/11.5c99d687.jpg";